import React from "react";
import showModal from "../../modal";

const Link = props => <a href="javascript:void(0);" onClick={props.onClick}>{props.children}</a>;

const Col = props => (
	<div className="row">
		<div className={props.className || 'col-xl-12'}>
			{props.children}
		</div>
	</div>
);

const Dt = props => <dt><Col className={props.className}>{props.children}</Col></dt>;
const Dd = props => <dd><Col className={props.className}>{props.children}</Col></dd>;

const Errors = props => {
	if(props.messages && props.messages instanceof Object && props.messages.hasOwnProperty(props.name)) {
		return <ul className={props.className ? props.className : 'errors'}>{props.messages[props.name].map(error => <li>{error}</li>)}</ul>;
	}
	return null;
};

const Steps = function (props) {
	if(props.step >= 0 && props.step < props.children.length) {
		return props.children[props.step];
	} else {
		return <div />;
	}
};

export class Create extends React.Component {
	lsPrefix = 'product-review-written';

	constructor(props) {
		super(props);
		this.state = {
			step: localStorage ? (localStorage.getItem(`${this.lsPrefix}-${this.props.id}`) ? 4 : 0) : 0,
			data: {},
			errors: {}
		};
	}

	setStep(step) {
		this.setState({step});
	}

	createNewReview(data) {
		this.setState({step: 2, data}, () => {
			$.ajax(this.props.target, {
				method: 'post',
				dataType: 'json',
				contentType: 'application/json',
				data: JSON.stringify(data)
			}).done(() => {
				if(localStorage) {
					localStorage.setItem(`${this.lsPrefix}-${this.props.id}`, 'yes');
				}
				this.setStep(3);
			}).catch(response => {
				try {
					const {responseJSON: {messages}} = response;
					this.setState({errors: messages});
					this.setStep(1);
				} catch (e) {
					alert('Es ist ein unbekannter Fehler aufgetreten.');
					this.setStep(1);
				}
			});
		});
	}

	render() {
		return (
			<Steps step={this.state.step}>
				<button className="btn btn-primary" onClick={() => this.setStep(1)}>Neue Bewertung verfassen</button>
				<CreateForm
					data={this.state.data}
					errors={this.state.errors}
					onSubmit={data => this.createNewReview(data)}
					onCancel={() => this.setState({step: 0})}
				/>
				<div>Ihre Bewertung wird übermittelt...</div>
				<div>
					<h5>Vielen Dank!</h5>
					<p>Es findet noch eine Prüfung statt, ob es sich bei der abgegebenen Bewertung um unzulässige Werbung handelt, bevor eine Freigabe erfolgt.</p>
				</div>
				<div>
					<h5>Vielen Dank!</h5>
					<p>Es wurde bereits eine Bewertung für dieses Produkt abgegeben. Vielen Dank!</p>
				</div>
			</Steps>
		);
	}
}

const StarSelect = function (props) {
	return (
		<div className="element--star-rating">
			{[1, 3, 5].map(n =>
				<a href="javascript:void(0);" onClick={() => props.onChange(n)} className={n === props.rating && 'selected'}>
					{n === props.rating ?
						<i className={`fa fa-2x ${['fa-thumbs-down', '', 'fa-thumbs-up fa-rotate-270', '', 'fa-thumbs-up'][n-1]}`} /> :
						<i className={`fa fa-2x ${['fa-thumbs-o-down', '', 'fa-thumbs-o-up fa-rotate-270', '', 'fa-thumbs-o-up'][n-1]}`} /> }
				</a>
			)}
		</div>
	);
};

class CreateForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = Object.assign({
			rating: 0,
			terms: false,
			termsVisible: false
		}, this.props.data);
	}

	setRating(rating) {
		this.setState({rating});
	}

	toggleTerms(e) {
		e.preventDefault();
		this.setState({termsVisible: !this.state.termsVisible});
	}

	setValue(e) {
		this.setState({[e.currentTarget.name]: e.currentTarget.value});
	}

	isValid() {
		return this.state.terms && (this.state.rating > 0);
	}

	submit(e) {
		e.preventDefault();
		this.props.onSubmit(this.state);
	}

	render() {
		return (
			<form className="form" action="javascript:void(0);" method="post" onSubmit={e => this.submit(e)}>
				<h3>Bewertung schreiben</h3>

				<Errors className="element--message-box errors" name="$overall" messages={this.props.errors} />

				<dl>
					<Dt>Ihre Bewertung</Dt>
					<Dd><StarSelect rating={this.state.rating} onChange={n => this.setRating(n)} /></Dd>
				</dl>
				{this.state.rating > 0 &&
					<dl>
						<Dt className="col-md-12"><div className="title">Titel ihrer Bewertung</div></Dt>
						<Dd className="col-md-8">
							<input type="text" name="title" value={this.state.title} onChange={e => this.setValue(e)} required />
							<Errors name="title" messages={this.props.errors} />
						</Dd>
						<Dt className="col-md-12"><div className="title">Ihre Bewertung</div></Dt>
						<Dd className="col-md-8">
							<textarea name="text" value={this.state.text} onChange={e => this.setValue(e)} required />
							<Errors name="text" messages={this.props.errors} />
						</Dd>
						<Dt className="col-md-12"><div className="title">Ihr angezeigter Name</div><small>(optional)</small></Dt>
						<Dd className="col-md-4">
							<input type="text" name="name" value={this.state.name} onChange={e => this.setValue(e)} required />
							<Errors name="name" messages={this.props.errors} />
						</Dd>
						<Dt className="col-md-12"><div className="title">Ihre Email-Adresse</div><small>(wird <u>nicht</u> veröffentlicht)</small></Dt>
						<Dd className="col-md-5">
							<input type="email" name="email" value={this.state.email} onChange={e => this.setValue(e)} required />
							<Errors name="email" messages={this.props.errors} />
						</Dd>
					</dl>
				}

				<div><label><input type="checkbox" checked={this.state.remember} onChange={e => this.setState({remember: e.currentTarget.checked})} /> Benutzername und Email-Adresse in diesem Browser merken?</label></div>
				<div><label><input type="checkbox" checked={this.state.terms} onChange={e => this.setState({terms: e.currentTarget.checked})} /> Bitte bestätigen Sie, dass Sie <Link onClick={() => showModal(this.termsHtml)}>die Bewertungsrichtlinien</Link> gelesen haben.</label></div>

				<div className="spacer" />

				{this.state.rating > 0 &&
					<nav>
						<button type="submit" className="btn btn-primary" disabled={!this.isValid()}><i className="fa fa-send" /> Bewertung abschicken</button>
						<span>&nbsp;</span>
						<button type="button" className="btn btn-default" onClick={() => this.props.onCancel()}><i className="fa fa-times" /> Abbrechen</button>
					</nav>
				}
			</form>
		);
	}

	termsHtml = `
		<h5>Richtlinien für die Bewertungen von Produkten</h5>
		<ul>
			<li>Geben Sie Ihre eigenen Erfahrungen und Meinungen wieder. Außerdem stimmen Sie zu alleiniger Urheber der Inhalte zu sein und alle Urheberrechte zu besitzen.</li>
			<li>Beschreiben Sie welche Vor- und/oder Nachteile das Produkt hat. Bewerten Sie ausschließlich das Produkt, wobei Vergleiche mit anderen Produkten zulässig sind.</li>
			<li>
				Jede Kundenmeinung wird vor einer Veröffentlichung redaktionell geprüft. Bitte achten Sie u.a. darauf, dass ...
				<ul>
					<li>Ihre Angaben weder falsch, noch irreführend oder ungenau sind, sowie kein Copyright, keine Marken-, kein Patent- und keine Veröffentlichungsrechte verletzen.</li>
					<li>Sich Ihre Angaben ausschließlich auf das Produkt und nicht den Preis oder sonstige zur Lieferung gehörenden Umstände beziehen (Nutzen Sie dafür unser Kontaktformular).</li>
					<li>Ihre Angaben keine anderen Angebote, Produkte, Anbieter oder sonstige Kontaktdaten beinhalten</li>
					<li>Ihre Angaben keinerlei Spam, Werbung oder andere unpassende Inhalte enthalten</li>
					<li>Sie nicht in Eigennutz handeln</li>
					<li>Ihre Angaben nicht auf andere Angebote, Produkte, Anbieter oder sonstige Kontakte verweisen oder solche Informationen beinhalten</li>
					<li>Sie keine Datenschutzrechte Dritter, keine sonstigen Rechte und keine Gesetze verletzen</li>
					<li>Sie keinerlei diskriminierende, gegen gute Sitten, rassistische oder sonstige gegen das geltende Recht verstoßende Aussagen treffen</li>
				</ul>
			</li>
		</ul>
	`;
}